import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';

import { useContext } from 'react';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { useMentorRequestContext } from './mentor-request-context';

import ConnectionInfo from '../connection-details/connection-info';

const MentorRequestParticipantInfo = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id: mentoringProgramId } = mentoringProgram;
  const { role, participant } = useMentorRequestContext();
  const isMentor = role === MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR;
  const roleParticipant = {
    name: isMentor ? MentoringProgramRole.MENTORSHIP_PROGRAM_MENTEE : MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR,
  };

  return (
    <div className='modal-panel connection-info'>
      <ConnectionInfo
        showAvailability
        user={participant?.user}
        role={roleParticipant}
        enrollmentId={participant?.id}
        mentorshipProgramId={mentoringProgramId}
      />
    </div>
  );
};

export default MentorRequestParticipantInfo;
